import Vue from 'vue';

Vue.filter('sizeOf', function sizeOfFilter(bytes) {
    if (bytes === 0) {
        return '0 B';
    }
    const value = Math.floor(Math.log(bytes) / Math.log(1024));
    return (bytes / Math.pow(1024, value)).toFixed(1) + ' ' + ' KMGTP'.charAt(value) + 'B';
});

Vue.filter('shortDate', function shortDateFilter(value) {
    const day = value.substr(8, 2);
    const month = value.substr(5, 2);

    return [day, month].join('/');
});

Vue.filter('ucfirst', function ucfirstFilter(value) {
    const string = String(value || '').trim();

    return string.charAt(0).toLocaleUpperCase() + string.slice(1);
});
